import { handleActions } from "redux-actions";
import { COLLECTIONS, IMPERSONATION } from "constants/action-types";

export interface IState {
    error?: Error;
    isFetching: boolean;
    result: string[];
    searchTerm?: string;
    impersonationRequestError?: Error;
    isFetchingImpersonationCode: boolean;
    impersonationCode?: any;
    impersonationToken?: any;
    enterImpersonationError?: Error;
    isFetchingImpersonationToken: boolean;
    stopImpersonationError?: Error;
    isStoppingImpersonation: boolean;
    stoppedImpersonation: boolean;
}

export const initialState: IState = {
    error: undefined,
    isFetching: false,
    isFetchingImpersonationCode: false,
    result: [],
    searchTerm: undefined,
    impersonationCode: undefined,
    impersonationToken: undefined,
    impersonationRequestError: undefined,
    isFetchingImpersonationToken: false,
    enterImpersonationError: undefined,
    stopImpersonationError: undefined,
    isStoppingImpersonation: false,
    stoppedImpersonation: false,
};

export const usersReducer = handleActions<IState, any>(
    {
        [COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.FETCH.START]: (state: IState) => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.FETCH.COMPLETED]: (state: IState, { error, payload }) => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                    isFetching: false,
                };
            }
            return {
                ...state,
                result: payload,
                isFetching: false,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.SEARCH]: (state: IState, { payload }) => {
            return {
                ...state,
                searchTerm: payload,
            };
        },
        [IMPERSONATION.REQUEST_IMPERSONATION.FETCH.START]: (state: IState): IState => {
            return Object.assign(state, { isFetchingImpersonationCode: true });
        },
        [IMPERSONATION.REQUEST_IMPERSONATION.FETCH.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    impersonationCode: undefined,
                    impersonationRequestError: payload,
                    isFetchingImpersonationCode: false,
                };
            } else {
                const newState = {
                    ...state,
                    impersonationCode: payload.impersonation_code,
                    isFetchingImpersonationCode: false,
                    impersonationRequestError: undefined,
                };
                return newState;
            }
        },
        [IMPERSONATION.ENTER_IMPERSONATION.CREATE.START]: (state: IState): IState => {
            return Object.assign(state, { isFetchingImpersonationToken: true });
        },
        [IMPERSONATION.ENTER_IMPERSONATION.CREATE.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    impersonationToken: undefined,
                    enterImpersonationError: payload,
                    isFetchingImpersonationToken: false,
                };
            } else {
                const newState = {
                    ...state,
                    impersonationToken: payload,
                    isFetchingImpersonationToken: false,
                    enterImpersonationError: undefined,
                };
                return newState;
            }
        },
        [IMPERSONATION.ENTER_IMPERSONATION.RESET]: (state: IState): IState => {
            return {
                ...state,
                impersonationToken: undefined,
                isFetchingImpersonationToken: false,
                enterImpersonationError: undefined,
            };
        },
        [IMPERSONATION.STOP_IMPERSONATION.FETCH.START]: (state: IState): IState => {
            return Object.assign(state, { isStoppingImpersonation: true });
        },
        [IMPERSONATION.STOP_IMPERSONATION.FETCH.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    stoppedImpersonation: false,
                    stopImpersonationError: payload,
                    isStoppingImpersonation: false,
                };
            } else {
                const newState = {
                    ...state,
                    stoppedImpersonation: true,
                    impersonationToken: undefined,
                    isStoppingImpersonation: false,
                    stopImpersonationError: undefined,
                };
                return newState;
            }
        },
    },
    initialState
);
